const kit = {
  isBlank: obj => {
    return obj === undefined || obj === null || obj.length === 0
  },
  postParam: param => {
    return {
      version: '1.11',
      data: param
    }
  },
  formatDateTime: time => {
    var date = new Date(time)
    var y = date.getFullYear()
    var m = date.getMonth() + 1
    m = m < 10 ? '0' + m : m
    var d = date.getDate()
    d = d < 10 ? '0' + d : d
    var h = date.getHours()
    h = h < 10 ? '0' + h : h
    var minute = date.getMinutes()
    var second = date.getSeconds()
    minute = minute < 10 ? '0' + minute : minute
    second = second < 10 ? '0' + second : second
    return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second
  },

  formatDateTime_1: time => {
    var date = new Date(time)
    var y = date.getFullYear()
    var m = date.getMonth() + 1
    m = m < 10 ? '0' + m : m
    var d = date.getDate()
    d = d < 10 ? '0' + d : d
    return y + "" + m + "" + d
  },

  getBeforeDay: day => {
    var today = new Date()
    var targetdayMilliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day
    today.setTime(targetdayMilliseconds)
    var tYear = today.getFullYear()
    var tMonth = today.getMonth()
    var tDate = today.getDate()

    function doHandleMonth(month) {
      var m = month
      if (month.toString().length === 1) {
        m = '0' + month
      }
      return m
    }

    tMonth = doHandleMonth(tMonth + 1)
    tDate = doHandleMonth(tDate)
    return tYear + '-' + tMonth + '-' + tDate
  },
  toThousands: function (num) {
    var result = []
    var counter = 0
    num = (num || 0).toString()
    var pointI = num.indexOf('.')
    var decimal = ''
    if (pointI !== -1) {
      decimal = num.substring(pointI)
      num = num.substring(0, pointI)
    }
    var minus = num.indexOf('-')
    if (minus !== -1) {
      num = num.substring(1)
    }
    num = num.split('')
    for (var i = num.length - 1; i >= 0; i--) {
      counter++
      result.unshift(num[i])
      if (!(counter % 3) && i !== 0) {
        result.unshift(',')
      }
    }
    if (decimal !== '') {
      result.push(decimal)
    }
    if (minus !== -1) {
      result.unshift('-')
    }

    return result.join('')
  },
  firstLetterToLower: word => {
    let a = word.split('')
    let b = a[0].toLowerCase()
    a.splice(0, 1, b)
    return a.join('')
  },

  formatNumber: function (num) {
    var pointI = num.indexOf('.')
    if (pointI > -1) {
      decimal = num.substring(pointI)
      num = num.substring(0, pointI)
    }
    return num
  }
}
export default kit



// WEBPACK FOOTER //
// ./src/common/kit.js